import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {OfferFilters} from "../../services/ngage/offers";

export default function useGetOffers(
  criteria: OfferFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['offers', criteria],
    () => ngage.offers.filtered(criteria),
    {enabled, keepPreviousData}
  );
}